import { render } from "./wokerDetail11.vue?vue&type=template&id=281b5ba3&scoped=true"
import script from "./wokerDetail11.vue?vue&type=script&lang=js"
export * from "./wokerDetail11.vue?vue&type=script&lang=js"

import "./wokerDetail11.vue?vue&type=style&index=0&id=281b5ba3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-281b5ba3"]])

export default __exports__